





























































































import Vue from 'vue'
export default Vue.extend({
  name: 'PSection',
  components: {
    PSubSection: () => import('./PSubSection.vue')
  },
  props: {
    protected: {
      type: Boolean,
      default: () => false
    },
    id: {
      type: String,
      required: true,
      default: 'default-psection-id'
    },
    title: {
      type: String,
      required: true,
      default: () => 'Default PSection Title'
    },
    description: {
      type: String,
      required: true,
      default: () => '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>'
    },
    thumb: {
      type: String,
      required: true,
      default: () => 'img/logo.png'
    },
    thumbLinkHome: {
      type: String,
      required: true,
      default: () => 'DefaultHomeUrl'
    },
    thumbLinkSchool: {
      type: String,
      default: () => 'DefaultSchoolUrl'
    },
    thumbLinkCamp: {
      type: String,
      default: () => 'DefaultCampUrl'
    },
    imagesAndDescriptions: {
      type: Array,
      default: () => [{ 'img': 'img/logo.png', 'description': 'DefaultImgDescription' }]
    }
  }
})
